export const STORAGE_FEATURE_STRINGS = {
  canResidentsUseIt: 'Can your residents use it?',
  inputPlaceholder: 'Where is it located?',
  yes: 'Yes',
  no: 'No',
};
